/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjectCheckRuleDto } from '../models/work-create-project-check-rule-dto';
import { WorkDuplicateProjectCheckRuleDto } from '../models/work-duplicate-project-check-rule-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProjectCheckRule } from '../models/work-project-check-rule';
import { WorkProjectCheckRuleTypeMetadataDto } from '../models/work-project-check-rule-type-metadata-dto';
import { WorkUpdateProjectCheckRuleDto } from '../models/work-update-project-check-rule-dto';
import { WorkUpdateSortOrderProjectCheckRulesDto } from '../models/work-update-sort-order-project-check-rules-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectCheckRulesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectCheckRulesV2ControllerGetRuleTypes()` */
  static readonly ProjectCheckRulesV2ControllerGetRuleTypesPath = '/v2/project-check-rules/rule-types';

  /**
   * Required permissions: project-check-rules:read, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerGetRuleTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerGetRuleTypes$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectCheckRuleTypeMetadataDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerGetRuleTypesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectCheckRuleTypeMetadataDto>>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:read, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerGetRuleTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerGetRuleTypes(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectCheckRuleTypeMetadataDto>> {
    return this.projectCheckRulesV2ControllerGetRuleTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectCheckRuleTypeMetadataDto>>): Array<WorkProjectCheckRuleTypeMetadataDto> => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerFindAllPaginated()` */
  static readonly ProjectCheckRulesV2ControllerFindAllPaginatedPath = '/v2/project-check-rules';

  /**
   * Required permissions: project-check-rules:read, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by enabled query param.
     *           <p>
     *              <b>Format: </b> filter.enabled={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.enabled=$not:$like:John Doe&filter.enabled=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.enabled'?: Array<string>;

    /**
     * Filter by ruleType query param.
     *           <p>
     *              <b>Format: </b> filter.ruleType={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.ruleType=$not:$like:John Doe&filter.ruleType=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.ruleType'?: Array<string>;

    /**
     * Filter by visibleInMontageplan query param.
     *           <p>
     *              <b>Format: </b> filter.visibleInMontageplan={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.visibleInMontageplan=$not:$like:John Doe&filter.visibleInMontageplan=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.visibleInMontageplan'?: Array<string>;

    /**
     * Filter by visibleForCustomer query param.
     *           <p>
     *              <b>Format: </b> filter.visibleForCustomer={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.visibleForCustomer=$not:$like:John Doe&filter.visibleForCustomer=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.visibleForCustomer'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> containertypeId:ASC,sortOrder:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>containertypeId</li>
     * <li>identifier</li>
     * <li>name</li>
     * <li>ruleType</li>
     * <li>enabled</li>
     * <li>sortOrder</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'identifier:ASC' | 'identifier:DESC' | 'name:ASC' | 'name:DESC' | 'ruleType:ASC' | 'ruleType:DESC' | 'enabled:ASC' | 'enabled:DESC' | 'sortOrder:ASC' | 'sortOrder:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> identifier,name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>identifier</li>
     * <li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectCheckRule>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'enabled'?: (string | Array<string>);
'ruleType'?: (string | Array<string>);
'visibleInMontageplan'?: (string | Array<string>);
'visibleForCustomer'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('filter.enabled', params['filter.enabled'], {});
      rb.query('filter.ruleType', params['filter.ruleType'], {});
      rb.query('filter.visibleInMontageplan', params['filter.visibleInMontageplan'], {});
      rb.query('filter.visibleForCustomer', params['filter.visibleForCustomer'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProjectCheckRule>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'containertypeId'?: (string | Array<string>);
        'enabled'?: (string | Array<string>);
        'ruleType'?: (string | Array<string>);
        'visibleInMontageplan'?: (string | Array<string>);
        'visibleForCustomer'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:read, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by enabled query param.
     *           <p>
     *              <b>Format: </b> filter.enabled={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.enabled=$not:$like:John Doe&filter.enabled=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.enabled'?: Array<string>;

    /**
     * Filter by ruleType query param.
     *           <p>
     *              <b>Format: </b> filter.ruleType={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.ruleType=$not:$like:John Doe&filter.ruleType=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.ruleType'?: Array<string>;

    /**
     * Filter by visibleInMontageplan query param.
     *           <p>
     *              <b>Format: </b> filter.visibleInMontageplan={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.visibleInMontageplan=$not:$like:John Doe&filter.visibleInMontageplan=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.visibleInMontageplan'?: Array<string>;

    /**
     * Filter by visibleForCustomer query param.
     *           <p>
     *              <b>Format: </b> filter.visibleForCustomer={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.visibleForCustomer=$not:$like:John Doe&filter.visibleForCustomer=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.visibleForCustomer'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> containertypeId:ASC,sortOrder:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>containertypeId</li>
     * <li>identifier</li>
     * <li>name</li>
     * <li>ruleType</li>
     * <li>enabled</li>
     * <li>sortOrder</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'identifier:ASC' | 'identifier:DESC' | 'name:ASC' | 'name:DESC' | 'ruleType:ASC' | 'ruleType:DESC' | 'enabled:ASC' | 'enabled:DESC' | 'sortOrder:ASC' | 'sortOrder:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> identifier,name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>identifier</li>
     * <li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectCheckRule>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'enabled'?: (string | Array<string>);
'ruleType'?: (string | Array<string>);
'visibleInMontageplan'?: (string | Array<string>);
'visibleForCustomer'?: (string | Array<string>);
};
};
}> {
    return this.projectCheckRulesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectCheckRule>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'enabled'?: (string | Array<string>);
'ruleType'?: (string | Array<string>);
'visibleInMontageplan'?: (string | Array<string>);
'visibleForCustomer'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProjectCheckRule>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'enabled'?: (string | Array<string>);
'ruleType'?: (string | Array<string>);
'visibleInMontageplan'?: (string | Array<string>);
'visibleForCustomer'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerCreate()` */
  static readonly ProjectCheckRulesV2ControllerCreatePath = '/v2/project-check-rules';

  /**
   * Required permissions: project-check-rules:create, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerCreate$Response(
    params: {
      body: WorkCreateProjectCheckRuleDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectCheckRule>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectCheckRule>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:create, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerCreate(
    params: {
      body: WorkCreateProjectCheckRuleDto
    },
    context?: HttpContext
  ): Observable<WorkProjectCheckRule> {
    return this.projectCheckRulesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectCheckRule>): WorkProjectCheckRule => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerFindOneById()` */
  static readonly ProjectCheckRulesV2ControllerFindOneByIdPath = '/v2/project-check-rules/{id}';

  /**
   * Required permissions: project-check-rules:read, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectCheckRule>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectCheckRule>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:read, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectCheckRule> {
    return this.projectCheckRulesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectCheckRule>): WorkProjectCheckRule => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerDelete()` */
  static readonly ProjectCheckRulesV2ControllerDeletePath = '/v2/project-check-rules/{id}';

  /**
   * Required permissions: project-check-rules:delete, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:delete, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCheckRulesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectCheckRulesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerUpdate()` */
  static readonly ProjectCheckRulesV2ControllerUpdatePath = '/v2/project-check-rules/{id}';

  /**
   * Required permissions: project-check-rules:update, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateProjectCheckRuleDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectCheckRule>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectCheckRule>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:update, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateProjectCheckRuleDto
    },
    context?: HttpContext
  ): Observable<WorkProjectCheckRule> {
    return this.projectCheckRulesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectCheckRule>): WorkProjectCheckRule => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerUpdateSortOrder()` */
  static readonly ProjectCheckRulesV2ControllerUpdateSortOrderPath = '/v2/project-check-rules/sort-order';

  /**
   * Required permissions: project-check-rules:update, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerUpdateSortOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerUpdateSortOrder$Response(
    params: {
      body: WorkUpdateSortOrderProjectCheckRulesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectCheckRule>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerUpdateSortOrderPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectCheckRule>>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:update, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerUpdateSortOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerUpdateSortOrder(
    params: {
      body: WorkUpdateSortOrderProjectCheckRulesDto
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectCheckRule>> {
    return this.projectCheckRulesV2ControllerUpdateSortOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectCheckRule>>): Array<WorkProjectCheckRule> => r.body)
    );
  }

  /** Path part for operation `projectCheckRulesV2ControllerDuplicate()` */
  static readonly ProjectCheckRulesV2ControllerDuplicatePath = '/v2/project-check-rules/{id}/duplicate';

  /**
   * Required permissions: project-check-rules:create, project-check-rules:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCheckRulesV2ControllerDuplicate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerDuplicate$Response(
    params: {
      id: number;
      body: WorkDuplicateProjectCheckRuleDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectCheckRule>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCheckRulesV2Service.ProjectCheckRulesV2ControllerDuplicatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectCheckRule>;
      })
    );
  }

  /**
   * Required permissions: project-check-rules:create, project-check-rules:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCheckRulesV2ControllerDuplicate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectCheckRulesV2ControllerDuplicate(
    params: {
      id: number;
      body: WorkDuplicateProjectCheckRuleDto
    },
    context?: HttpContext
  ): Observable<WorkProjectCheckRule> {
    return this.projectCheckRulesV2ControllerDuplicate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectCheckRule>): WorkProjectCheckRule => r.body)
    );
  }

}
